import { additionalFieldsMixin } from 'mixins'
import { mapGetters } from 'vuex'

const _sortItems = (items) => {
  return items.sort((a, b) => a.order - b.order)
}
const _hasChanged = (newValue, oldValue) => {
  if (!oldValue) {
    return true
  }
  try {
    return JSON.stringify(newValue) !== JSON.stringify(oldValue)
  } catch (e) {
    return true
  }
}


export default {
  mixins: [ additionalFieldsMixin ],
  methods: {
    sendEventCreateAdditionalFieldRule(oldFields = [], newFields = [], exist, tender) {
      // на шаге с данными тендера не нужны правила по лотам
      // иначе при изменении категории у которой будут обязательные поля по лоту, не сможем сохранить
      if (this.currentStepProps?.component === 'TenderInformation' && !tender) {
        return
      }
      if (!oldFields?.length) {
        this.$root.$emit('createRuleAdditionalFields', {value: newFields, exist, tender})
        return
      }
      const oldIds = oldFields.map(i => i.id)
      const newIds = newFields.map(i => i.id)
      const arraysHaveDifferences = (array1, array2) => {
        if (array1.length !== array2.length) {
          return true
        }

        const sortedArray1 = [...array1].sort((a, b) => a - b)
        const sortedArray2 = [...array2].sort((a, b) => a - b)

        for (let i = 0; i < sortedArray1.length; i++) {
          if (sortedArray1[i] !== sortedArray2[i]) {
            return true
          }
        }

        return false
      }

      if (arraysHaveDifferences(oldIds, newIds)) {
        this.$root.$emit('createRuleAdditionalFields', {value: newFields, exist, tender})
      }
    },
    async mixin_getFieldsByBindConditions(props) {
      await this.$store.dispatch('editTenderStore/getAdditionalFieldsByBindingConditions', props)
    }
  },
  computed: {
    ...mapGetters({
      getter_additionalFieldsTenderNew: 'editTenderStore/additionalFieldsTenderNew',
      getter_additionalFieldsTenderExists: 'editTenderStore/additionalFieldsTenderExists',
      getter_additionalFieldsEntityLots: 'editTenderStore/additionalFieldsEntityLots',

      getter_additionalFieldsLotsNew: 'editTenderStore/additionalFieldsLotsNew',
      getter_additionalFieldsLotsExists: 'editTenderStore/additionalFieldsLotsExists',

      currentStepProps: 'editTenderStore/tenderFlouCurrentStepProps'
    }),
    additionalFieldsTender: {
      get() {
        return [...this.additionalFieldsTenderExists.map(i => ({...i, new: false})), ...this.additionalFieldsTenderNew.map(i => ({...i, new: true}))]
      },
      set(newValue) {
        this.additionalFieldsTenderNew = newValue.filter(i => i.new || i.new === undefined) || []
        this.additionalFieldsTenderExists = newValue.filter(i => !i.new && i.new !== undefined) || []
      }
    },
    additionalFieldsTenderNew: {
      get() {
        return this.getter_additionalFieldsTenderNew || []
      },
      set(newValue = [], oldValue = []) {
        if (!newValue.length) {
          this.$store.dispatch('editTenderStore/setAdditionalFieldsTenderNew', {values: []})
        } else if (!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.$store.dispatch('editTenderStore/setAdditionalFieldsTenderNew', {values: newValue.sort((a, b) => a.order - b.order)})
        }
      }
    },
    additionalFieldsTenderExists: {
      get() {
        return this.getter_additionalFieldsTenderExists
      },
      set(newValue = [], oldValue = []) {
        if (!newValue.length) {
          this.$store.dispatch('editTenderStore/setAdditionalFieldsTenderExists', {values: []})
        } else if (!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.$store.dispatch('editTenderStore/setAdditionalFieldsTenderExists', {items: newValue.sort((a, b) => a.order - b.order)})
        }
      }
    },

    additionalFieldsLots: {
      get() {
        return [
          ...this.additionalFieldsLotsExists.map(i => ({ ...i, new: false })),
          ...this.additionalFieldsLotsNew.map(i => ({ ...i, new: true }))
        ]
      },
      set(newValue) {
        const newFields = newValue.filter(i => i.new || i.new === undefined) || []
        const existingFields = newValue.filter(i => !i.new && i.new !== undefined) || []

        this.additionalFieldsLotsExists = existingFields
        this.additionalFieldsLotsNew = newFields
      }
    },

    additionalFieldsLotsNew: {
      get() {
        return this.getter_additionalFieldsLotsNew || []
      },
      set(newValue) {
        if (_hasChanged(newValue, this.additionalFieldsLotsNew)) {
          // Безопасное клонирование для защиты от циклов и реактивности
          let safeItems = []
          try {
            safeItems = JSON.parse(JSON.stringify(_sortItems(newValue)))
          } catch (e) {
            // fallback: если не сериализуется, отправляем пустой массив
            safeItems = []
          }
          this.$store.dispatch('editTenderStore/setAdditionalFieldsLotsNew', {
            items: safeItems
          })
        }
      }
    },

    additionalFieldsLotsExists: {
      get() {
        return this.getter_additionalFieldsLotsExists
      },
      set(newValue) {
        if (_hasChanged(newValue, this.additionalFieldsLotsExists)) {
          this.$store.dispatch('editTenderStore/setAdditionalFieldsLotsExists', {
            items: _sortItems(newValue)
          })
        }
      }
    },
  },
  watch: {
    additionalFieldsTenderNew: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.sendEventCreateAdditionalFieldRule(oldValue, newValue, false, true)
        }
      }
    },
    additionalFieldsTenderExists: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.sendEventCreateAdditionalFieldRule(oldValue, newValue, true, true)
        }
      }
    },

    additionalFieldsLotsNew: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.sendEventCreateAdditionalFieldRule(oldValue, newValue, false, false)
        }
      }
    },
    additionalFieldsLotsExists: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.sendEventCreateAdditionalFieldRule(oldValue, newValue, true, false)
        }
      }
    },
  }
}
